/* Promage — custom behaviors (loaded on every page, deferred).
   Effects are device-scoped via pm-custom.css: on desktop the markup added
   here stays inert and invisible. */
(function () {
  function addToggle(el) {
    el.classList.add('pm-collapsible', 'is-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-viewmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'View more';
    btn.addEventListener('click', function () {
      var collapsed = el.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      btn.textContent = collapsed ? 'View more' : 'View less';
    });
    el.after(btn);
  }

  /* Related products ("You may also like"): the section renders text-only
     cards, so fetch each product's featured image and prepend it to the
     card. The figure is only shown on phones via pm-custom.css. */
  function addRecImage(card) {
    if (card.querySelector('.pm-rec-fig') || card.dataset.pmRecImg) return;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    card.dataset.pmRecImg = 'true';
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.featured_image || card.querySelector('.pm-rec-fig')) return;
        var src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        var fig = document.createElement('div');
        fig.className = 'pm-rec-fig';
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = p.title || '';
        img.src = src;
        fig.appendChild(img);
        card.prepend(fig);
      })
      .catch(function () {});
  }

  function initRecImages() {
    var sec = document.querySelector('.shopify-section--product-recommendations');
    if (!sec) return;
    var apply = function () {
      sec.querySelectorAll('.product-card').forEach(addRecImage);
    };
    apply();
    /* Recommendations can render after page load — keep watching. */
    new MutationObserver(apply).observe(sec, { childList: true, subtree: true });
  }

  function init() {
    /* Product feature list: headings stay, descriptions expand. */
    document.querySelectorAll('.pm-ab-dl').forEach(function (dl) {
      if (dl.dataset.pmCollapsible) return;
      if (!dl.querySelector(':scope > .pm-ab-row > dd')) return;
      dl.dataset.pmCollapsible = 'true';
      addToggle(dl);
    });
    /* Specifications table: first rows stay, the rest expand. */
    document.querySelectorAll('dl.pm-sp').forEach(function (dl) {
      if (dl.dataset.pmCollapsible) return;
      if (dl.querySelectorAll(':scope > .pm-sp-i').length <= 7) return;
      dl.dataset.pmCollapsible = 'true';
      addToggle(dl);
    });
    initRecImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
